var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "top" }, on: { click: _vm.closeSelect } },
    [
      _c("headNav", { attrs: { gray: _vm.gray } }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "innerWrapper" },
        [
          _c("h1", [_vm._v("Reservation form")]),
          _vm._v(" "),
          _c("div", { staticClass: "container" }, [
            _c("div", { staticClass: "info" }, [
              _c("div", { staticClass: "top" }, [
                _vm._v("$" + _vm._s(_vm.item.price))
              ]),
              _vm._v(" "),
              _c("h2", [_vm._v(_vm._s(_vm.item.proertyType))]),
              _vm._v(" "),
              _c("h3", [
                _vm.item.apt
                  ? _c("i", { staticStyle: { "font-style": "normal" } }, [
                      _vm._v(_vm._s(_vm.item.apt) + " / ")
                    ])
                  : _vm._e(),
                _vm._v(
                  _vm._s(_vm.item.address) +
                    " " +
                    _vm._s(_vm.item.suburb) +
                    "\n        "
                )
              ]),
              _vm._v(" "),
              _c("h6", [
                _vm._v(_vm._s(_vm.item.state) + " " + _vm._s(_vm.item.postcode))
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "dtl", class: "tenant-" + _vm.tenant }, [
                _c("p", [
                  _c("span", [_vm._v("Estimated commencement")]),
                  _c("span", [_vm._v(_vm._s(_vm.item.estimatedCommenceMent))])
                ]),
                _vm._v(" "),
                _c("p", [
                  _c("span", [_vm._v("Estimated completion")]),
                  _c("span", [_vm._v(_vm._s(_vm.item.estimatedCompletion))])
                ]),
                _vm._v(" "),
                _c("p", [
                  _vm._m(0),
                  _vm._v(" "),
                  _c("span", { staticStyle: { "margin-top": ".05rem" } }, [
                    _vm._v(
                      "\n              $" +
                        _vm._s(_vm.item.rental) +
                        "\n              "
                    ),
                    _vm.item.maxRental &&
                    _vm.item.maxRental !== "" &&
                    _vm.item.maxRental !== 0 &&
                    _vm.item.maxRental !== "0"
                      ? _c(
                          "i",
                          {
                            staticStyle: {
                              "font-style": "normal",
                              display: "block",
                              "line-height": ".2rem",
                              float: "none",
                              "text-align": "left"
                            }
                          },
                          [_vm._v("\n                -\n              ")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.item.maxRental &&
                    _vm.item.maxRental !== "" &&
                    _vm.item.maxRental !== 0 &&
                    _vm.item.maxRental !== "0"
                      ? _c(
                          "i",
                          {
                            staticStyle: {
                              "font-style": "normal",
                              display: "block",
                              float: "none",
                              "text-align": "left"
                            }
                          },
                          [_vm._v("$" + _vm._s(_vm.item.maxRental))]
                        )
                      : _vm._e()
                  ])
                ]),
                _vm._v(" "),
                _vm.item.proertyType === "House & Land"
                  ? _c("p", [
                      _c("span", [_vm._v("Land price")]),
                      _c("span", [_vm._v("$" + _vm._s(_vm.item.landPrice))])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.item.proertyType === "House & Land"
                  ? _c("p", [
                      _c("span", [_vm._v("Build price")]),
                      _c("span", [_vm._v("$" + _vm._s(_vm.item.buildPrice))])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("p", [
                  _c("span", [_vm._v("Rental yield")]),
                  _c("span", [_vm._v(_vm._s(_vm.item.rentalYield) + "%")])
                ]),
                _vm._v(" "),
                _c("p", [
                  _c("span", [_vm._v("Incentives")]),
                  _c("span", {
                    domProps: { innerHTML: _vm._s(_vm.item.incentives) }
                  })
                ])
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "dtls" },
              [
                _c("h1", { class: "tenant-" + _vm.tenant }, [
                  _vm._v("Purchaser details")
                ]),
                _vm._v(" "),
                _vm._l(_vm.allPurchaser, function(purchaser, index) {
                  return _c("div", { key: index }, [
                    _c("h2", [
                      _vm._v("Purchaser #" + _vm._s(purchaser.purchaserId))
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "selectItem" }, [
                      _c("div", { staticClass: "title" }, [_vm._v("Title")]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "select",
                          class: {
                            open: purchaser.open,
                            red: purchaser.titleWarn
                          }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "mol",
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  return _vm.openSelect(
                                    purchaser.purchaserId,
                                    "title"
                                  )
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(purchaser.title) +
                                  "\n              "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("transition", { attrs: { name: "fade" } }, [
                            purchaser.open
                              ? _c(
                                  "ul",
                                  { staticStyle: { height: "3.6rem" } },
                                  _vm._l(_vm.options, function(item) {
                                    return _c(
                                      "li",
                                      {
                                        key: item.key,
                                        class: {
                                          selected:
                                            item.value == purchaser.title
                                        },
                                        on: {
                                          click: function($event) {
                                            $event.stopPropagation()
                                            return _vm.posChange(
                                              purchaser.purchaserId,
                                              item.value
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                    " +
                                            _vm._s(item.value) +
                                            "\n                  "
                                        )
                                      ]
                                    )
                                  }),
                                  0
                                )
                              : _vm._e()
                          ])
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "inputItem" }, [
                      _c(
                        "div",
                        { staticClass: "title", attrs: { id: "first" } },
                        [_vm._v("First name")]
                      ),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: purchaser.firstName,
                            expression: "purchaser.firstName"
                          }
                        ],
                        class: { red: _vm.signFirName || purchaser.fristWarn },
                        attrs: { maxlength: "25", type: "text" },
                        domProps: { value: purchaser.firstName },
                        on: {
                          change: _vm.name,
                          input: [
                            function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                purchaser,
                                "firstName",
                                $event.target.value
                              )
                            },
                            _vm.validateWarn
                          ],
                          "!blur": function($event) {
                            return _vm.isFilled($event)
                          }
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "inputItem" }, [
                      _c(
                        "div",
                        { staticClass: "title", attrs: { id: "sur" } },
                        [_vm._v("Surname")]
                      ),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: purchaser.surName,
                            expression: "purchaser.surName"
                          }
                        ],
                        class: { red: _vm.signSurName || purchaser.surWarn },
                        attrs: { maxlength: "25", type: "text" },
                        domProps: { value: purchaser.surName },
                        on: {
                          change: _vm.name,
                          input: [
                            function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                purchaser,
                                "surName",
                                $event.target.value
                              )
                            },
                            _vm.validateWarn
                          ],
                          "!blur": function($event) {
                            return _vm.isFilled($event)
                          }
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "inputItem" }, [
                      _c("div", { staticClass: "title" }, [_vm._v("Address")]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: purchaser.address,
                            expression: "purchaser.address"
                          }
                        ],
                        class: { red: purchaser.addressWarn },
                        attrs: { maxlength: "100", type: "text" },
                        domProps: { value: purchaser.address },
                        on: {
                          input: [
                            function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                purchaser,
                                "address",
                                $event.target.value
                              )
                            },
                            _vm.validateWarn
                          ],
                          "!blur": function($event) {
                            return _vm.isFilled($event)
                          }
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "inputItem" }, [
                      _c("div", { staticClass: "title" }, [_vm._v("Suburb")]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: purchaser.suburb,
                            expression: "purchaser.suburb"
                          }
                        ],
                        class: { red: purchaser.suburbWarn },
                        attrs: { maxlength: "50", type: "text" },
                        domProps: { value: purchaser.suburb },
                        on: {
                          input: [
                            function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(purchaser, "suburb", $event.target.value)
                            },
                            _vm.validateWarn
                          ],
                          "!blur": function($event) {
                            return _vm.isFilled($event)
                          }
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "selectItem" }, [
                      _c("div", { staticClass: "title" }, [_vm._v("State")]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "select",
                          class: {
                            open: purchaser.open2,
                            red: purchaser.stateWarn
                          }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "mol",
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  return _vm.openSelect(
                                    purchaser.purchaserId,
                                    "state"
                                  )
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(purchaser.state) +
                                  "\n              "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("transition", { attrs: { name: "fade" } }, [
                            purchaser.open2
                              ? _c(
                                  "ul",
                                  { staticStyle: { height: "6.3rem" } },
                                  _vm._l(_vm.optionsState, function(item) {
                                    return _c(
                                      "li",
                                      {
                                        key: item.key,
                                        class: {
                                          selected:
                                            item.value == purchaser.state
                                        },
                                        on: {
                                          click: function($event) {
                                            $event.stopPropagation()
                                            return _vm.posChange2(
                                              purchaser.purchaserId,
                                              item.value
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                    " +
                                            _vm._s(item.value) +
                                            "\n                  "
                                        )
                                      ]
                                    )
                                  }),
                                  0
                                )
                              : _vm._e()
                          ])
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "inputItem" }, [
                      _c("div", { staticClass: "title" }, [_vm._v("Postcode")]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: purchaser.postcode,
                            expression: "purchaser.postcode"
                          }
                        ],
                        class: { red: purchaser.postcodeWarn },
                        attrs: { type: "number" },
                        domProps: { value: purchaser.postcode },
                        on: {
                          input: [
                            function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                purchaser,
                                "postcode",
                                $event.target.value
                              )
                            },
                            function($event) {
                              return _vm.validateWarn(
                                $event,
                                "code",
                                purchaser.purchaserId
                              )
                            }
                          ],
                          "!blur": function($event) {
                            return _vm.isFilled($event)
                          }
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "inputItem" }, [
                      _c("div", { staticClass: "title" }, [_vm._v("Mobile")]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: purchaser.mobile,
                            expression: "purchaser.mobile"
                          }
                        ],
                        class: { red: purchaser.mobileWarn },
                        attrs: { type: "number" },
                        domProps: { value: purchaser.mobile },
                        on: {
                          input: [
                            function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(purchaser, "mobile", $event.target.value)
                            },
                            function($event) {
                              return _vm.validateWarn(
                                $event,
                                "mobile",
                                purchaser.purchaserId
                              )
                            }
                          ],
                          "!blur": function($event) {
                            return _vm.isFilled($event)
                          }
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "inputItem" }, [
                      _c(
                        "div",
                        { staticClass: "title", attrs: { id: "emil" } },
                        [_vm._v("Email")]
                      ),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: purchaser.email,
                            expression: "purchaser.email"
                          }
                        ],
                        class: { red: purchaser.emailwarn },
                        attrs: { type: "text" },
                        domProps: { value: purchaser.email },
                        on: {
                          change: function($event) {
                            return _vm.validateEmail(
                              $event,
                              purchaser.purchaserId
                            )
                          },
                          input: [
                            function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(purchaser, "email", $event.target.value)
                            },
                            _vm.validateWarn
                          ],
                          "!blur": function($event) {
                            return _vm.isFilled($event)
                          }
                        }
                      }),
                      _vm._v(" "),
                      purchaser.emailwarn
                        ? _c("i", {
                            staticClass: "close",
                            on: {
                              click: function($event) {
                                return _vm.clean("email", purchaser.purchaserId)
                              }
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      purchaser.emailwarn
                        ? _c("strong", [
                            _vm._v(
                              "Email format is incorrect. Please try again."
                            )
                          ])
                        : _vm._e()
                    ])
                  ])
                }),
                _vm._v(" "),
                _vm.allPurchaser.length < 10
                  ? _c("h4", { on: { click: _vm.add } }, [
                      _vm._v(
                        "\n          Add another purchaser's details\n        "
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "inputItem",
                    staticStyle: { "margin-bottom": "16px" }
                  },
                  [
                    _c("div", { staticClass: "title" }, [
                      _vm._v("Purchasing entity")
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.purchasingEntity,
                          expression: "purchasingEntity"
                        }
                      ],
                      attrs: { maxlength: "1024", type: "text" },
                      domProps: { value: _vm.purchasingEntity },
                      on: {
                        input: [
                          function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.purchasingEntity = $event.target.value
                          },
                          _vm.validateWarn
                        ],
                        "!blur": function($event) {
                          return _vm.isFilled($event)
                        }
                      }
                    })
                  ]
                ),
                _vm._v(" "),
                _c("h5", [
                  _vm._v("Only if purchasing outside of personal name")
                ]),
                _vm._v(" "),
                _c(
                  "h1",
                  {
                    class: "tenant-" + _vm.tenant,
                    staticStyle: { "margin-bottom": ".92rem" }
                  },
                  [
                    _vm._v(
                      "\n          Purchaser's conveyancer/solicitor\n        "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "newCheck clear" },
                  [
                    _c("el-checkbox", {
                      staticClass: "checkleft",
                      model: {
                        value: _vm.checked,
                        callback: function($$v) {
                          _vm.checked = $$v
                        },
                        expression: "checked"
                      }
                    }),
                    _vm._v(" "),
                    _vm._m(1)
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "inputItem" }, [
                  _c("div", { staticClass: "title" }, [_vm._v("Company name")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.legal.companyName,
                        expression: "legal.companyName"
                      }
                    ],
                    class: { red: _vm.legal.companyWarn },
                    attrs: { maxlength: "50", type: "text" },
                    domProps: { value: _vm.legal.companyName },
                    on: {
                      input: [
                        function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.legal,
                            "companyName",
                            $event.target.value
                          )
                        },
                        _vm.legalhandleInput
                      ],
                      "!blur": function($event) {
                        return _vm.isFilled($event)
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "inputItem" }, [
                  _c("div", { staticClass: "title" }, [
                    _vm._v("Contact person")
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.legal.person,
                        expression: "legal.person"
                      }
                    ],
                    class: { red: _vm.legal.personWarn },
                    attrs: { maxlength: "50", type: "text" },
                    domProps: { value: _vm.legal.person },
                    on: {
                      input: [
                        function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.legal, "person", $event.target.value)
                        },
                        _vm.legalhandleInput
                      ],
                      "!blur": function($event) {
                        return _vm.isFilled($event)
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "inputItem" }, [
                  _c("div", { staticClass: "title" }, [_vm._v("Address")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.legal.address,
                        expression: "legal.address"
                      }
                    ],
                    class: { red: _vm.legal.addressWarn },
                    attrs: { maxlength: "100", type: "text" },
                    domProps: { value: _vm.legal.address },
                    on: {
                      input: [
                        function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.legal, "address", $event.target.value)
                        },
                        _vm.legalhandleInput
                      ],
                      "!blur": function($event) {
                        return _vm.isFilled($event)
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "inputItem" }, [
                  _c("div", { staticClass: "title" }, [_vm._v("Suburb")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.legal.suburb,
                        expression: "legal.suburb"
                      }
                    ],
                    class: { red: _vm.legal.suburbWarn },
                    attrs: { maxlength: "50", type: "text" },
                    domProps: { value: _vm.legal.suburb },
                    on: {
                      input: [
                        function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.legal, "suburb", $event.target.value)
                        },
                        _vm.legalhandleInput
                      ],
                      "!blur": function($event) {
                        return _vm.isFilled($event)
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "selectItem" }, [
                  _c("div", { staticClass: "title" }, [_vm._v("State")]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "select",
                      class: {
                        open: _vm.legal.openState,
                        red: _vm.legal.stateWarn
                      }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "mol",
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              return _vm.openlegel($event)
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.legal.state))]
                      ),
                      _vm._v(" "),
                      _c("transition", { attrs: { name: "fade" } }, [
                        _vm.legal.openState
                          ? _c(
                              "ul",
                              { staticStyle: { height: "6.3rem" } },
                              _vm._l(_vm.optionsState, function(item) {
                                return _c(
                                  "li",
                                  {
                                    key: item.key,
                                    class: {
                                      selected: item.value == _vm.legal.state
                                    },
                                    on: {
                                      click: function($event) {
                                        $event.stopPropagation()
                                        return _vm.posChange3(item.value)
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(item.value) +
                                        "\n                "
                                    )
                                  ]
                                )
                              }),
                              0
                            )
                          : _vm._e()
                      ])
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "inputItem" }, [
                  _c("div", { staticClass: "title" }, [_vm._v("Postcode")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.legal.postcode,
                        expression: "legal.postcode"
                      }
                    ],
                    class: { red: _vm.legal.postcodeWarn },
                    attrs: { type: "number" },
                    domProps: { value: _vm.legal.postcode },
                    on: {
                      input: [
                        function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.legal, "postcode", $event.target.value)
                        },
                        function($event) {
                          return _vm.legalhandleInput($event, "code")
                        }
                      ],
                      "!blur": function($event) {
                        return _vm.isFilled($event)
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "inputItem" }, [
                  _c("div", { staticClass: "title" }, [_vm._v("Phone")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.legal.phone,
                        expression: "legal.phone"
                      }
                    ],
                    class: { red: _vm.legal.phoneWarn },
                    attrs: { type: "number" },
                    domProps: { value: _vm.legal.phone },
                    on: {
                      input: [
                        function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.legal, "phone", $event.target.value)
                        },
                        function($event) {
                          return _vm.legalhandleInput($event, "phone")
                        }
                      ],
                      "!blur": function($event) {
                        return _vm.isFilled($event)
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "inputItem" }, [
                  _c("div", { staticClass: "title" }, [_vm._v("Mobile")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.legal.mobile,
                        expression: "legal.mobile"
                      }
                    ],
                    class: { red: _vm.legal.mobileWarn },
                    attrs: { type: "number" },
                    domProps: { value: _vm.legal.mobile },
                    on: {
                      input: [
                        function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.legal, "mobile", $event.target.value)
                        },
                        function($event) {
                          return _vm.legalhandleInput($event, "mobile")
                        }
                      ],
                      "!blur": function($event) {
                        return _vm.isFilled($event)
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "inputItem" }, [
                  _c("div", { staticClass: "title" }, [_vm._v("Email")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.legal.email,
                        expression: "legal.email"
                      }
                    ],
                    class: { red: _vm.legal.emailWarn },
                    attrs: { type: "text" },
                    domProps: { value: _vm.legal.email },
                    on: {
                      change: _vm.legalValidateEmail,
                      input: [
                        function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.legal, "email", $event.target.value)
                        },
                        _vm.legalhandleInput
                      ],
                      "!blur": function($event) {
                        return _vm.isFilled($event)
                      }
                    }
                  }),
                  _vm._v(" "),
                  _vm.legal.emailWarn
                    ? _c("i", {
                        staticClass: "close",
                        on: { click: _vm.legalClean }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.legal.emailWarn
                    ? _c("strong", [
                        _vm._v("Email format is incorrect. Please try again.")
                      ])
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c("h1", { class: "tenant-" + _vm.tenant }, [
                  _vm._v(
                    "\n          Executed as an agreement (By Client or Referrer on behalf of client)\n        "
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "inputItem" }, [
                  _c("div", { staticClass: "title" }, [_vm._v("Name")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.agreementName,
                        expression: "agreementName"
                      }
                    ],
                    class: { red: _vm.agreementNameWarn },
                    attrs: { maxlength: "50", type: "text" },
                    domProps: { value: _vm.agreementName },
                    on: {
                      input: [
                        function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.agreementName = $event.target.value
                        },
                        _vm.validateWarn
                      ],
                      "!blur": function($event) {
                        return _vm.isFilled($event)
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "inputItem" }, [
                  _c("div", { staticClass: "title" }, [_vm._v("Date")]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "date reserve",
                      class: { red: _vm.agreementDateWarn }
                    },
                    [
                      _c("el-date-picker", {
                        attrs: {
                          editable: false,
                          format: "dd/MM/yyyy",
                          placeholder: "select",
                          type: "date",
                          "value-format": ""
                        },
                        on: { change: _vm.dateChange },
                        model: {
                          value: _vm.agreementDate,
                          callback: function($$v) {
                            _vm.agreementDate = $$v
                          },
                          expression: "agreementDate"
                        }
                      })
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    class: { active: _vm.haveSign },
                    on: { click: _vm.toSign }
                  },
                  [_vm._v("\n          Sign reservation form\n        ")]
                ),
                _vm._v(" "),
                _c("h1", { class: "tenant-" + _vm.tenant }, [
                  _vm._v("Introducer's details")
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "clear" }, [
                  _vm._v("\n          Company name:"),
                  _c("i", [_vm._v(_vm._s(_vm.user.companyName))])
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "clear" }, [
                  _vm._v("\n          Contact person:"),
                  _c("i", [
                    _vm._v(
                      _vm._s(_vm.user.firstName) +
                        " " +
                        _vm._s(_vm.user.lastName)
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "clear" }, [
                  _vm._v("\n          Address:"),
                  _c("i", [
                    _vm._v(
                      _vm._s(_vm.user.address) +
                        ", " +
                        _vm._s(_vm.user.suburb) +
                        ", " +
                        _vm._s(_vm.user.state) +
                        ",\n            " +
                        _vm._s(_vm.user.postcode)
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "clear" }, [
                  _vm._v("\n          Phone number:"),
                  _c("i", [_vm._v(_vm._s(_vm.user.phoneNumber))])
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "clear" }, [
                  _vm._v("\n          Mobile:"),
                  _c("i", [_vm._v(_vm._s(_vm.user.mobileNumber))])
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "clear" }, [
                  _vm._v("\n          Email"),
                  _c("i", [_vm._v(_vm._s(_vm.user.email))])
                ]),
                _vm._v(" "),
                _c("button", { on: { click: _vm.edit } }, [
                  _vm._v("Edit my details")
                ])
              ],
              2
            ),
            _vm._v(" "),
            _c("div", { staticClass: "payWrp" }, [
              _c("h1", [_vm._v("Payment")]),
              _vm._v(" "),
              _c("div", { staticClass: "inputItem" }, [
                _c("div", { staticClass: "title" }, [_vm._v("Card name")]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.cardInfo.cardName,
                      expression: "cardInfo.cardName"
                    }
                  ],
                  class: { red: _vm.cardInfo.cardNameWarn },
                  attrs: { maxlength: "40", type: "text" },
                  domProps: { value: _vm.cardInfo.cardName },
                  on: {
                    input: [
                      function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.cardInfo, "cardName", $event.target.value)
                      },
                      function($event) {
                        return _vm.cardHandleInput($event, "name")
                      }
                    ],
                    "!blur": function($event) {
                      return _vm.isFilled($event)
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "out" }, [
                _c("div", { staticClass: "bigInputItem" }, [
                  _c("div", { staticClass: "title" }, [_vm._v("Card number")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.cardInfo.cardNumber,
                        expression: "cardInfo.cardNumber"
                      }
                    ],
                    class: { red: _vm.cardInfo.cardNumberWarn },
                    attrs: { maxlength: "16", type: "number" },
                    domProps: { value: _vm.cardInfo.cardNumber },
                    on: {
                      input: [
                        function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.cardInfo,
                            "cardNumber",
                            $event.target.value
                          )
                        },
                        function($event) {
                          return _vm.cardHandleInput($event, "number")
                        }
                      ],
                      "!blur": function($event) {
                        return _vm.isFilled("validate")
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("i", {
                    class: {
                      visa: _vm.cardType == "visa",
                      master: _vm.cardType == "master"
                    }
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "tripleInputItem clear" }, [
                  _c("div", { staticClass: "smlInputItem" }, [
                    _c("div", { staticClass: "inn" }, [
                      _c("div", { staticClass: "title" }, [_vm._v("Expiry")]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "input clear",
                          class: { red: _vm.cardInfo.cardDate }
                        },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.cardInfo.cardMonth,
                                expression: "cardInfo.cardMonth"
                              }
                            ],
                            ref: "month",
                            attrs: { maxlength: "2", type: "number" },
                            domProps: { value: _vm.cardInfo.cardMonth },
                            on: {
                              input: [
                                function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.cardInfo,
                                    "cardMonth",
                                    $event.target.value
                                  )
                                },
                                function($event) {
                                  return _vm.cardHandleInput($event, "month")
                                }
                              ],
                              "!blur": function($event) {
                                return _vm.isFilled($event)
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("span", [_vm._v("/")]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.cardInfo.cardYear,
                                expression: "cardInfo.cardYear"
                              }
                            ],
                            ref: "year",
                            attrs: { maxlength: "2", type: "number" },
                            domProps: { value: _vm.cardInfo.cardYear },
                            on: {
                              input: [
                                function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.cardInfo,
                                    "cardYear",
                                    $event.target.value
                                  )
                                },
                                function($event) {
                                  return _vm.cardHandleInput($event, "year")
                                }
                              ],
                              "!blur": function($event) {
                                return _vm.isFilled($event)
                              }
                            }
                          })
                        ]
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "smlInputItem" }, [
                    _c("div", { staticClass: "inn" }, [
                      _c("div", { staticClass: "title" }, [_vm._v("CVV")]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.cardInfo.cardCvv,
                            expression: "cardInfo.cardCvv"
                          }
                        ],
                        class: { red: _vm.cardInfo.cardCvvWarn },
                        attrs: { maxlength: "3", type: "number" },
                        domProps: { value: _vm.cardInfo.cardCvv },
                        on: {
                          input: [
                            function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.cardInfo,
                                "cardCvv",
                                $event.target.value
                              )
                            },
                            function($event) {
                              return _vm.cardHandleInput($event, "cvv")
                            }
                          ],
                          "!blur": function($event) {
                            return _vm.isFilled($event)
                          }
                        }
                      })
                    ])
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "p1" }, [
                _vm._v(
                  "\n          Please note the $1000 reservation fee is completely refundable\n          should you not go ahead to contract. An additional transaction fee\n          of 3% + 30c for domestic and international cards is a non-refundable\n          fee.\n        "
                )
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "p2" }, [
                _vm._v(
                  "\n          Secure payment transactions powered by Stripe and secured with\n          256-bit encryption.\n        "
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "more" }, [
              _c("h2", [
                _vm._v(
                  "\n          Congratulations on your property reservation. You will receive a\n          call from an UNIFI representative within the next 24 hours.\n        "
                )
              ]),
              _vm._v(" "),
              _c("button", { on: { click: _vm.submit } }, [
                _vm._v("Pay & submit reservation")
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "\n          Once UNIFI has accepted this reservation the purchaser is entitled\n          to a 7 day exclusive period, free of competition, to seek advice and\n          proceed with the sale.\n        "
                )
              ])
            ])
          ]),
          _vm._v(" "),
          _c("transition", { attrs: { name: "fade" } }, [
            _vm.showsign
              ? _c("div", { staticClass: "popWrp" }, [
                  _c("div", { staticClass: "out" }, [
                    _c("div", { staticClass: "inn" }, [
                      _c("h2", [
                        _vm._v(
                          "\n              Please read the reservation form in detail and sign at the\n              corresponding location.\n            "
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticClass: "close",
                          attrs: { href: _vm.link, target: "_self" },
                          on: { click: _vm.closesign }
                        },
                        [_vm._v("Okay")]
                      )
                    ])
                  ])
                ])
              : _vm._e()
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c("foot-nav")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [
      _vm._v("Estimated rental"),
      _c("br"),
      _vm._v("(per week)")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "p" }, [
      _c("b", [
        _vm._v(
          "Please check the box if you currently do not have a\n              conveyancer/solicitor. An approved UNIFI conveyancer/solicitor\n              will be provided for you."
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f54568bc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f54568bc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/details/property/write.vue
// module id = null
// module chunks = 